module.exports = __webpack_public_path__ + "img/scene_tv_time_big@2x.5d4557fe.png";